






















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  emits: ['next', 'previous'],
  props: {
    /**
     * should the left control be displayed?
     */
    useLeft: {
      type: Boolean,
      required: true,
    },
    /**
     * should the right control be displayed?
     */
    useRight: {
      type: Boolean,
      required: true,
    },
  },
  name: 'BaseModpackControls',
  setup: (props, { emit }) => ({ emit }),
});
